import React, { useCallback, useEffect, useState } from 'react'
import { FormControl, ListItemText, ListSubheader, MenuItem, Select } from '@mui/material'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import TabletMacIcon from '@mui/icons-material/TabletMac';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import styled from 'styled-components';

const RESPONSIVE_OPTIONS = [
  {
    name: 'Responsive',
    options: [
      {
        name: 'Responsive zoom at 100%',
        zoom: 100,
        icon: <AspectRatioIcon/>,
      },
      {
        name: 'Responsive zoom at 50%',
        zoom: 50,
        icon: <AspectRatioIcon/>,
      },
    ]
  },
  {
    name: 'Mobile',
    options: [
      {
        name: 'iPhone 5',
        width: 320,
        height: 568,
        icon: <PhoneAndroidIcon/>,
      },
      {
        name: 'Galaxy S7',
        usage: 14,
        width: 360,
        height: 640,
        icon: <PhoneAndroidIcon/>,
      },
      {
        name: 'iPhone 6/6S/7',
        usage: 7,
        width: 375,
        height: 667,
        icon: <PhoneAndroidIcon/>,
      },
      {
        name: 'iPhone 10/X',
        usage: 6,
        width: 375,
        height: 812,
        icon: <PhoneAndroidIcon/>,
      },
      {
        name: 'iPhone XS Plus/XR',
        usage: 8,
        width: 414,
        height: 896,
        icon: <PhoneAndroidIcon/>,
      },    
    ]
  },
  {
    name: 'Tablet',
    options: [
      {
        name: 'iPad Mini/Air',
        usage: 45,
        width: 768,
        height: 1024,
        icon: <TabletMacIcon/>,
      },    
      {
        name: 'Samsung Galaxy Tab 10',
        usage: 8,
        width: 800,
        height: 1280,
        icon: <TabletMacIcon/>,
      },    
      {
        name: 'iPad Pro',
        width: 1024,
        height: 1366,
        icon: <TabletMacIcon/>,
      },    
    ]
  },
  {
    name: 'Desktop',
    options: [
      {
        name: 'Usual resolution',
        usage: 20,
        width: 1366,
        height: 768,
        icon: <DesktopWindowsIcon/>,
      },
      {
        name: 'Usual resolution',
        usage: 7,
        width: 1440,
        height: 900,
        icon: <DesktopWindowsIcon/>,
      },
      {
        name: 'Usual resolution',
        usage: 10,
        width: 1536,
        height: 864,
        icon: <DesktopWindowsIcon/>,
      },
      {
        name: 'Usual resolution',
        usage: 21,
        width: 1920,
        height: 1080,
        icon: <DesktopWindowsIcon/>,
      },
      {
        name: 'Usual resolution',
        usage: 22,
        width: 1280,
        height: 720,
        icon: <DesktopWindowsIcon/>,
      },      
    ]
  },
]

const StyledSelect = styled(Select)`
  .MuiSelect-outlined {
    padding: 4px 14px;
  }
`

const renderResponsiveName = (entry) => {
  const properties = []
  if (entry.width) properties.push(`${entry.width}x${entry.height}`)
  if (entry.zoom) properties.push(`${entry.zoom}% zoom`)
  if (entry.usage) properties.push(`${entry.usage}% usage`)
  return `${entry.name} (${properties.join(', ')})`
}

const ResponsiveDropDown = ({ onChange }) => {
  const [selectedResolution, setSelectedResolution] = useState(RESPONSIVE_OPTIONS[0].options[0])

  const handleChange = useCallback((event) => setSelectedResolution(event.target.value), []);

  useEffect(() => {
    onChange(selectedResolution.width, selectedResolution.height, selectedResolution.zoom)
  }, [selectedResolution, onChange])

  return (
    <FormControl size="small" variant='outlined'>
      <StyledSelect
        value={selectedResolution}
        onChange={handleChange}
        renderValue={renderResponsiveName}
      >
        {RESPONSIVE_OPTIONS.map(group => (
          [
            <ListSubheader key={group.name}>{group.name}</ListSubheader>,
            group.options.map((entry, index) => (
              <MenuItem key={index} value={entry} onClick={() => {}}>
                {entry.icon}
                <ListItemText primary={renderResponsiveName(entry)} />
              </MenuItem>
            ))
          ]
        ))}
      </StyledSelect>
    </FormControl>
  )
}

export default ResponsiveDropDown